import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const DaybookServices = {
  getList: async (date) => {
    // Add date parameter to API call
    const response = await apiService.get(`/${slug}/daybook/getdaybookreport`, {
      params: { date },
    });
    return response.data;
  },
};

export default DaybookServices;
